<ng-container *transloco="let t; prefix: this.scope">
  <section class="">
    <p class="text-xl font-semibold">{{ t('currentMonthlyCost') }}</p>
    <section class="space-y-2">
      <ng-container *ngIf="isLoading();">
        <div class="animate-pulse space-y-2">
          <div class="h-6 bg-blg-grey-100 rounded w-full"></div>
          <div class="h-6 bg-blg-grey-100 rounded w-full"></div>
          <div class="h-6 bg-blg-grey-100 rounded w-full"></div>
          <div class="h-6 bg-blg-grey-100 rounded w-full"></div>
          <div class="h-6 bg-blg-grey-100 rounded w-full"></div>
        </div>
      </ng-container>
      <div class="flex flex-row w-full text-base font-normal">
        <div class="w-full flex flex-col">
          <div class="w-full flex" *ngIf="bundleExpense?.name">
            <div class="inline-flex mb-1">
              <span class="font-medium">{{ bundleExpense?.name }}</span>
              <div *ngIf="!isMiniPackage" class="ml-3">
                <bl-frontend-badge variant="info" [text]="bundleExpense.totalSubscribers + ' ' + getFullUserLabel(bundleExpense.totalSubscribers)"></bl-frontend-badge>
              </div>
            </div>
          </div>
          <div
            class="w-full flex pl-4 text-sm"
            *ngIf="bundleExpense && bundleExpense.regularSubscribers >= 1 && !isMiniPackage">
            <div>- {{ t('freeUser') }}</div>
          </div>
          <div
            class="w-full flex pl-4 text-sm"
            *ngIf="bundleExpense && bundleExpense.regularSubscribers > 1">
            <div>
              - {{ t('additionalUsers') }} ({{ bundleExpense.regularSubscribers - 1 }}
              {{ getUserLabel(bundleExpense.regularSubscribers - 1) }})
            </div>
          </div>
          <div
            class="w-full flex pl-4 text-sm"
            *ngIf="bundleExpense?.allInclusiveSubscribers > 0 && !isMiniPackage">
            <div>
              - {{ t('firmUser') }} ({{ bundleExpense.allInclusiveSubscribers }}
              {{ getUserLabel(bundleExpense.allInclusiveSubscribers) }})
            </div>
          </div>
        </div>
      </div>
      <div
        class="justify-between flex flex-row text-base font-normal"
        *ngFor="let row of moduleExpenses">
        <div *ngIf="row.name !== 'E-faktura'" class="w-full flex flex-col">
          <div class="w-full flex">
            <div class="inline-flex mb-1">
              <span class="font-medium">{{ row.name }}</span>
              <ng-container
                *ngIf="
                  row.blaProductId !== 'peppolin' && row.blaProductId !== 'peppolut' && row.blaProductId !== 'app_arkiv_ater'
                ">
                <div class="ml-3">
                  <bl-frontend-badge variant="info" [text]="row.totalSubscribers + ' ' + getFullUserLabel(row.totalSubscribers)"></bl-frontend-badge>
                </div>
              </ng-container>
            </div>
          </div>
          <!-- <div class="w-full flex pl-4 text-sm">
            <div>- {{ t('modulePrice') }}</div>
          </div> -->
          <div class="w-full flex pl-4 text-sm" *ngIf="row.allInclusiveSubscribers > 0">
            <div>
              - {{ t('firmUser') }} ({{ row.allInclusiveSubscribers }} {{ getUserLabel(row.allInclusiveSubscribers) }})
            </div>
          </div>
        </div>
      </div>
      <div class="justify-between flex flex-col text-sm font-normal">
        <ng-container *ngFor="let row of integrationExpenses">
          <div
            *ngIf="row.totalCost !== 0"
            class="justify-between w-full flex flex-col text-base font-normal">
            <div class="justify-between w-full flex">
              <div class="font-medium">
                {{ row.name }}
              </div>
            </div>
          </div>
        </ng-container>
      </div>
    </section>
    <!-- separator line -->
    <hr class="my-4 border-blg-grey-100" />

    <div class="flex flex-row justify-between text-lg font-semibold">
      <span> {{ t('totalMonthlyCost') }}</span>
      <span class="text-xl">
        {{ pricePrefix }}{{ totalAmountBilled | price: 1 }}{{ priceSuffix }}
      </span>
    </div>
  </section>
</ng-container>
